export enum NavigationName {
  APP = 'app',
  DASHBOARD = 'admin.dashboard',
}

export enum AppNavigationName {
  HOME = 'home',
  CONNECTION = 'connection',
  QUESTION = 'question',
  DISCUSSION = 'discussion',
  MORE = 'more',
}

export enum NavigationAction {
  RESET_QUESTION = 'reset-question',
}
